import { alpha } from "@mui/material";
import type { Theme } from "@mui/material/styles";

/**
 * Shared surfaces for the full-screen patient flows (welcome survey, questionnaire).
 *
 * These screens were authored light-only: each pinned its paper to
 * `linear-gradient(to bottom, #f8fafc, #ffffff)` and its cards to `rgba(255,255,255,0.9)`,
 * while the content inside used theme tokens for text. Under a dark theme that painted
 * near-white `text.primary` onto a white ground — so the welcome survey's heading and every
 * questionnaire question rendered invisible rather than merely low-contrast.
 *
 * They live here rather than inline because the same three literals had already been copied
 * across four components; the next copy is the one that gets missed.
 */

/** The full-screen sheet behind a patient flow: the theme's canvas fading into paper. */
export const sheetBackground = (theme: Theme) =>
  `linear-gradient(to bottom, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`;

/** A translucent card or footer sitting on top of {@link sheetBackground}. */
export const translucentSurface = (theme: Theme, opacity = 0.9) =>
  alpha(theme.palette.background.paper, opacity);

/**
 * Text on the brand hero gradient. A `contained` button defaults to `primary.contrastText`, which
 * is DARK under the dark palette — that is why the questionnaire's Next button once rendered black
 * on the gradient; read this instead.
 */
export const onBrandGradient = (theme: Theme) => theme.palette.brand.onHero;
